// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — toggle.styled.classic.js, новая — toggle.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './toggle.styled.classic';
import * as cp from './toggle.styled.cp';

export const Content = isCp ? cp.Content : classic.Content;
export const Title = isCp ? cp.Title : classic.Title;
